export enum VersionType {
    GENERATED = 'GENERATED',
    EDIT = 'EDIT',
    ADDED = 'ADDED',
    DELETED = 'DELETED',
    CONFIRMED = 'CONFIRMED',
}
